module.exports = __webpack_public_path__ + "static/media/netflix-clone.c580ccff.webp";